import cards from './cards'
import containers from './containers'
import elements from './elements'
import forms from './forms'
import graphics from './graphics'
import loaders from './loaders'
import other from './other'
import Ripple from './ripple'
import type { App } from 'vue'

const components = {
    ...elements,
    ...containers,
    ...loaders,
    ...other,
    ...forms,
    ...graphics,
    ...cards,
}

const directives = [Ripple]

const install = (app: App) => {
    Object.values(directives).forEach((directive) => {
        app.directive(directive.name, directive.logic)
    })

    Object.keys(components).forEach((componentName) => {
        app.component(componentName, components[componentName as keyof typeof components])
    })
}

export default install
